import { Home } from './Pages/Home';
import { Dashboard } from './Pages/Dashboard';
import { useState } from 'react';
import './reset.css'


const App = () => {
  const [listTransactions, setListTransactions] = useState([])
  const [page, setPage] = useState('home');

  return (
    <>
    {
      page === 'home' ? <Home setPage={setPage} page={page}/> 
      :  <Dashboard setPage={setPage} page={page} listTransactions={listTransactions} setListTransactions={setListTransactions}/>
    }
    </>
    
  );
}

export default App;
